import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import qs from 'qs'

class AdRetails {
  constructor () {
    const base = axios.create({
      baseURL: process.env.VUE_APP_PROMO_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.adRetails = base
  }

  async getAdPlanners (party_id, offset = 0, limit = 25, store_id = null, grid_submitted = null, approved = null) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: '/ad_planners',
      method: 'GET',
      params: { party_id, offset, limit, grid_submitted, approved, store_id }
    })
  }
  
  async getAd(ad_id) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad/${ad_id}`,
      method: 'GET'
    })
  }

  async getSuggestedAdPlanners (party_id, store_id, offset = 0, limit = 25, grid_submitted = true, approved = false) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/suggested_order_planners/${party_id}/${store_id}`,
      method: 'GET',
      params: { party_id, offset, limit, grid_submitted, approved }
    })
  }

  async getPages (ad_id, from_order_grid = false, suggested_order = false, meat_grid = false) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_items_page_num/${ad_id}`,
      method: 'GET',
      params: {
        from_order_grid: from_order_grid,
        suggested_grid: suggested_order,
        meat: meat_grid
      }
    })
  }

  async getDepartments (ad_id, from_order_grid = false, suggested_order = false, meat_grid = false) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_items_department/${ad_id}`,
      method: 'GET',
      params: {
        from_order_grid: from_order_grid,
        suggested_grid: suggested_order,
        meat: meat_grid
      }
    })
  }

  async getFeatureType(ad_id, from_order_grid = false, suggested_order = false, meat_grid = false) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_items_feature_type/${ad_id}`,
      method: 'GET',
      params: {
        from_order_grid: from_order_grid,
        suggested_grid: suggested_order,
        meat: meat_grid
      }
    })
  }

  async getFeatureText(ad_id, from_order_grid = false, suggested_order = false, meat_grid = false) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_items_feature_text/${ad_id}`,
      method: 'GET',
      params: {
        from_order_grid: from_order_grid,
        suggested_grid: suggested_order,
        meat: meat_grid
      }
    })
  }

  async getOrderGridData(
    searchParams,
    party_id,
    ad_id,
    suggested_order,
    meat_grid,
    storeDeliveryDays,
    offset = 0,
    limit = 50
  ) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/build_order_grid/${party_id}/${ad_id}`,
      method: "GET",
      params: {
        ...searchParams,
        suggested_grid: suggested_order,
        meat: meat_grid,
        delivery_days: storeDeliveryDays,
        offset: offset,
        limit: limit
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false, encode: true })
      }
    })
  }

  async getShipperComponents (ad_id, feature_id, shipper_id) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_planner/shipper_components/${ad_id}/${feature_id}`,
      method: 'GET',
      params: { shipper_id }
    })
  }

  async getRetailAdItems (ad_id, params) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_planner_item/${ad_id}`,
      method: 'GET',
      params: params
    })
  }

  async getRetailAdEditItems (ad_id, params) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_planner_item_edit/${ad_id}`,
      method: 'GET',
      params: params
    })
  }

  async updateRetailAd (ad_id, item_data) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_planner_changes/${ad_id}`,
      method: 'PUT',
      data: item_data
    })
  }

  async createSuggestedAdStatus(ad_data) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/suggested_order_status`,
      method: 'POST',
      data: ad_data
    })
  }

  async updateSuggestedAdStatus(ad_data, batch_id) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/suggested_order_status/${batch_id}`,
      method: 'PUT',
      data: ad_data
    })
  }

  async exportEditCSV(ad_id, params, headers) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_planner_edit/csv/${ad_id}`,
      method: 'POST',
      params: params,
      data: headers
    })
  }

  async getChanges(ad_id, store_id, params) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/ad_planner_changes/${ad_id}/${store_id}`,
      method: 'GET',
      params: params
    })
  }

  async publishChangesToOrderGrid(ad_id, store_id, params) {
    await AuthToken.setAuth(this.adRetails, {
      audience: process.env.VUE_APP_PROMO_AUDIENCE
    })
    return this.adRetails({
      url: `/publish_ad_planner_changes/${ad_id}/${store_id}`,
      method: 'POST',
      params: params
    })
  }
}

export default new AdRetails()
